module.exports = __webpack_public_path__ + "img/jose-maria-da-fonseca.55610f58.jpg";